import { render, staticRenderFns } from "./FeedbackDetails.vue?vue&type=template&id=0e6cea2c&scoped=true"
import script from "./FeedbackDetails.vue?vue&type=script&lang=js"
export * from "./FeedbackDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6cea2c",
  null
  
)

export default component.exports